<template>
  <div class="smart">
    <!-- banner部分 -->
    <div class="smart-banner clearfix">
      <div>
        <h2>智慧景区</h2>
        <h3>景区停车管理系统</h3>
      </div>
    </div>
    <!-- 方案概述 -->
    <div class="container clearfix">
      <div class="smart-title">方案概述</div>
      <div class="smart-overview mb100">
        <!-- <div class="fl">
          <img src="../../../assets/img/smart/zhdp_summary_Image.png" alt="" />
        </div> -->
        <div>
          <h2>景区停车管理系统</h2>
          <p>
            停车智能化发展有赖于智能停车管理系统的建设。停车智能化发展是推动智慧景区建设不可或缺的重要一环，随着停车智能化浪潮的逐渐推进。智能停车管理系统不仅引进了国外的先进的技术而且提出了新的停车管理理念，它的良好应用不仅有利于构建景区交通的动静态平衡，更能切实的改善停车问题从而提升景区的形象。因此在智慧景区发展的必经之路上，智能停车管理系统将会发挥更加重要的作用。
          </p>
        </div>
      </div>
    </div>
    <!-- 方案优势 -->
    <div class="container clearfix">
      <div class="smart-title">方案优势</div>
      <ul class="smart-strength clearfix">
        <li>
          <h2>私有化云</h2>
          <p>所有数据都私有化，所有停车场的数据都跑在自己的服务器上，数据安全可靠。再也不用担心自己的数据被泄漏了。</p>
        </li>
        <li>
          <h2>快速支付</h2>
          <p>车主可以通过微信扫码和关注就可以停车缴费，跟车牌识别系统完美结合，让停车更高效。操作更简单，用户体验好，只要会玩微信就能上手使用。</p>
        </li>
        <li>
          <h2>停车场管理</h2>
          <p>管理人员可以对停车场的运营状态实时检测 ，对多个停车场数据分析，财务报表智能分析，帮助管理人员做出重大决策。</p>
        </li>
        <li>
          <h2>优惠管理</h2>
          <p>商户可以向消费的车主发放停车券，商户提前向平台购买优惠券。随时随地管理自己的账户和发放停车优惠券。</p>
        </li>
        <li>
          <h2>快速接入</h2>
          <p>系统接口全面开放，第三方平台可以轻松接入。平台对接方便快捷，接口文档简洁实用还带有demo。</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'scenicparkmanagerSystem',
};
</script>
<style scoped>
.smart-banner {
  width: 100%;
  height: 594px;
  background: #000;
}
.smart-banner div {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url(../../../assets/img/smart/backgroundscenic_Image.png) no-repeat;
  background-size: cover;
}
.smart-banner h2 {
  margin-top: 182px;
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.smart-banner h3 {
  text-align: center;
  font-size: 30px;
  font-weight: 400;
  color: #fff;
}
.smart-title {
  width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #000;
}
.smart-overview {
  width: 100%;
  height: 334px;
}
.smart-overview p {
  font-size: 18px;
  font-weight: 400;
  color: #666;
  text-indent: 2em;
  line-height: 1.8;
}
.smart-overview h2 {
  text-align: center;
  margin-bottom: 45px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
}
.smart-strength {
  display: table;
  margin-right: -132px;
}
.smart-strength li {
  float: left;
  width: 366px;
  height: 160px;
  margin-right: 41px;
  margin-bottom: 50px;
}
.smart-strength li h2 {
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: bold;
  color: #333;
}
.smart-strength li p {
  font-size: 18px;
  font-weight: 400;
  color: #333;
  line-height: 1.6;
}
</style>
